/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.0.4
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../../reducers/rootReducer';
import { IChangePasswordState } from '../types/changePasswordTypes';

export const getChangePasswordState = (state: IRootReducer) => state.auth.changePassword || {};

export const makeSelectChangePassword = (): OutputSelector<IRootReducer, IChangePasswordState,
    (state: IChangePasswordState) => IChangePasswordState> =>
    createSelector(
        getChangePasswordState,
        (state: IChangePasswordState) => state,
    );
